import { useEffect, useState } from 'react';

const ImageAsync = (props) => {
    const [loadedSrc, setLoadedSrc] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoadedSrc(null);
        if (props.src) {
            const handleLoad = () => {
                setLoading(false);
                setLoadedSrc(props.src);
            };
            const image = new Image();
            image.addEventListener('load', handleLoad);
            image.src = props.src;
            image.onerror = () => setLoading(false);
            return () => {
                image.removeEventListener('load', handleLoad);
            };
        }
    }, [props.src]);

    if (loading) {
        return <img {...props} alt='dynamic' src='/assets/img/loader.gif' />;
    }

    if (loadedSrc === props.src) {
        return (
            <img {...props} alt='dynamic' />
        );
    }
    return <img {...props} alt='dynamic' src='https://www.sinrumbofijo.com/wp-content/uploads/2016/05/default-placeholder.png' />;
};

export default ImageAsync;
